module.exports = __webpack_public_path__ + "media/images/our_apps/header-f3b024b660cd1c9d314bf0840f94ae80.png";